import React from 'react';
import { useViewModule, useSeenModulePixel } from 'hook/helper.hook';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { CREDIT_CARD_COMPARISON } from 'types/morph.pagePosition.constants';
import CreditCardComparisonView from './CreditCardComparisonView';

const CreditCardComparisonController = props => {
  const { modulePosition, cardComparisonAttributes } = props;
  const atr = getViewModuleTrackingAttributes(
    CREDIT_CARD_COMPARISON,
    modulePosition,
  );

  useViewModule(atr);
  const seenPixel = useSeenModulePixel(atr);

  return (
    <CreditCardComparisonView
      seenPixel={seenPixel}
      onClose={cardComparisonAttributes?.onCloseCompareModule}
    />
  );
};

export default CreditCardComparisonController;
